import { PROD_HOST, STAGING_HOST } from './constants';

const sortFunc = (presetA, presetB) => presetA.name.localeCompare(presetB.name);
const BASE_URL = getAssetBaseUrl();

export function parsePresets(presets) {
    if (!presets) {
        return [];
    }
    const { custom, default: defaultPresets } = presets;
    const presetsToDisplay = custom?.length > 0 ? custom : defaultPresets;
    return presetsToDisplay.filter(({ presetTypes }) => presetTypes.includes('image')).sort(sortFunc);
}

export function getResourceUrl({ cloudName, asset, transformation }) {
    const { resource_type: resourceType, type, version, public_id: publicId } = asset;
    return `https://${BASE_URL}/${cloudName}/${resourceType}/${type}/${transformation}/v${version}/${publicId}`;
}

export const getAssets = (assets, selectedPreset, cloudName) => {
    const assetUrls = [];
    assets.forEach((asset) => {
        assetUrls.push({
            filename: `${asset.filename}.${asset.format}`,
            url: getResourceUrl({ asset, transformation: selectedPreset, cloudName })
        });
    });

    return assetUrls;
};

function getAssetBaseUrl() {
   return document.referrer?.includes('staging.cloudinary.com') || document.referrer?.includes('0.0.0.0') ? STAGING_HOST : PROD_HOST;
}
